import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { ICheckboxProps } from '@cb/apricot-react';

import Checkbox from './Checkbox';

interface ICheckboxFieldProps extends ICheckboxProps {
  name: string;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

const CheckboxField: FC<ICheckboxFieldProps> = ({ label, name, className, readOnly }) => {
  const { register, setValue, watch, unregister } = useFormContext();

  const value = watch(name);

  useEffect(() => {
    register(name);
    setValue(name, value);

    return () => {
      unregister(name);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register, unregister, name]);

  const handleChange = (checked: boolean): void => {
    if (readOnly) return;
    setValue(name, checked ? 'yes' : '');
  };

  return <Checkbox label={label} className={className} checked={!!value} onChange={handleChange} />;
};

export default CheckboxField;
